var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65859 11.0497C9.55859 11.0397 9.43859 11.0397 9.32859 11.0497C6.94859 10.9697 5.05859 9.01969 5.05859 6.61969C5.05859 4.16969 7.03859 2.17969 9.49859 2.17969C11.9486 2.17969 13.9386 4.16969 13.9386 6.61969C13.9286 9.01969 12.0386 10.9697 9.65859 11.0497Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9112 4.17969C18.8512 4.17969 20.4112 5.74969 20.4112 7.67969C20.4112 9.56969 18.9113 11.1097 17.0413 11.1797C16.9613 11.1697 16.8713 11.1697 16.7812 11.1797",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65875 14.7397C2.23875 16.3597 2.23875 18.9997 4.65875 20.6097C7.40875 22.4497 11.9188 22.4497 14.6688 20.6097C17.0888 18.9897 17.0888 16.3497 14.6688 14.7397C11.9288 12.9097 7.41875 12.9097 4.65875 14.7397Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8398 20.1797C19.5598 20.0297 20.2398 19.7397 20.7998 19.3097C22.3598 18.1397 22.3598 16.2097 20.7998 15.0397C20.2498 14.6197 19.5798 14.3397 18.8698 14.1797",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers2);
export default __webpack_public_path__ + "static/media/users2.f98bd6845069b7c735a5cdd324e8646f.svg";
export { ForwardRef as ReactComponent };